import { render, staticRenderFns } from "./OnlineView.vue?vue&type=template&id=0c3aefac&scoped=true&lang=pug"
import script from "./OnlineView.vue?vue&type=script&lang=ts"
export * from "./OnlineView.vue?vue&type=script&lang=ts"
import style0 from "./OnlineView.vue?vue&type=style&index=0&id=0c3aefac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3aefac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3aefac')) {
      api.createRecord('0c3aefac', component.options)
    } else {
      api.reload('0c3aefac', component.options)
    }
    module.hot.accept("./OnlineView.vue?vue&type=template&id=0c3aefac&scoped=true&lang=pug", function () {
      api.rerender('0c3aefac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Online/OnlineView.vue"
export default component.exports